import Timeslot, { Conflict, HrResolutionStatuses } from "app/models/timeslot"
import { Action, Types } from "./planningTimeslots.actions"

export type Params = {
  from: string
  to: string
  hr_resolution?: HrResolutionStatuses
}

export type PlanningTimeslotState = {
  errors: {}
  loading: boolean
  data: Timeslot[]
  highlightedUserId: string
  selectedTimeslotId: number | null
}

const initialState: PlanningTimeslotState = {
  data: [],
  errors: {},
  loading: false,
  highlightedUserId: "",
  selectedTimeslotId: null,
}

export default (state = initialState, action: Action): PlanningTimeslotState => {
  switch (action.type) {
    case Types.POST:
      return {
        ...state,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PATCH:
      return {
        ...state,
      }

    case Types.PATCH_SUCCESS:
      return {
        ...state,
      }

    case Types.PATCH_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
      }

    case Types.PATCH_CONFLICT:
      return {
        ...state,
        data: state.data.map(ts => {
          if (ts.id === action.payload.timeslotId) {
            return {
              ...ts,
              conflicts:
                (ts.conflicts &&
                  ts.conflicts.map((conflict: Conflict) => {
                    if (conflict.id === action.payload.data.id) {
                      return action.payload.data
                    }
                    return conflict
                  })) ||
                [],
            }
          }
          return ts
        }),
      }

    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data || [],
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.DELETE:
      return {
        ...state,
      }

    case Types.DELETE_SUCCESS:
      return {
        ...state,
        data: state.data.filter(ts => ts.id !== action.payload.data.id),
      }

    case Types.DELETE_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
      }

    case Types.HIGHLIGHT_USER:
      return {
        ...state,
        highlightedUserId: action.payload.id,
      }
    case Types.SELECT_TIMESLOT_SET:
      return {
        ...state,
        selectedTimeslotId: action.payload.timeslotId,
      }

    case Types.SELECT_TIMESLOT_RESET:
      return {
        ...state,
        selectedTimeslotId: null,
      }

    default:
      return state
  }
}
